// Shared JSON-LD helpers. Each inject function appends a <script> to <head> and
// returns a cleanup that removes it, so page-level effects stay self-contained.

// Builds an absolute, deployment-aware URL (honours the site's base path).
export function siteUrl(path: string): string {
  const basePath = __BASE_PATH__.replace(/\/$/, '');
  return `${window.location.origin}${basePath}${path}`;
}

// Injects an arbitrary schema.org object as a JSON-LD script tag.
export function injectJsonLd(data: Record<string, unknown>): () => void {
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.textContent = JSON.stringify(data);
  document.head.appendChild(script);
  return () => script.remove();
}

// Injects a BreadcrumbList (Home › Page) so search results can render the path.
export function injectBreadcrumbSchema(label: string, path: string): () => void {
  return injectJsonLd({
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl('/') },
      { '@type': 'ListItem', position: 2, name: label, item: siteUrl(path) },
    ],
  });
}

// Injects FAQPage markup. Pass the SAME questions and answers that render on the
// page so the structured data and the visible content can never diverge.
export function injectFaqSchema(items: { q: string; a: string }[]): () => void {
  return injectJsonLd({
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((item) => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.a,
      },
    })),
  });
}